import { initializeApp } from "firebase/app";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const deployedOnTestServer = import.meta.env.VITE_DEV_DEPLOYMENT;
const localFirebaseFunctions = import.meta.env.VITE_FIREBASE_LOCAL_FUNCTIONS;
const localFirebaseDatabase = import.meta.env.VITE_FIREBASE_LOCAL_DATABASE;

const prodConfig = {
  // see https://console.cloud.google.com/apis/credentials?project=cioos-metadata-form-8d942
  // and https://console.cloud.google.com/apis/credentials?project=cioos-metadata-form-dev-258dc
  // for api key location which is then stored in a github secret and added to several
  // github actions to support testing and deployment.
  // see https://firebase.google.com/docs/projects/api-keys for a discussion of why we
  // don't need to restrict api keys for firebase but might in some situations.
  // To prevent the future foot gun, we are restricting the key now.
  apiKey: import.meta.env.VITE_GOOGLE_CLOUD_API_KEY,
  authDomain: "cioos-metadata-form-8d942.web.app",
  databaseURL: "https://cioos-metadata-form-8d942-default-rtdb.firebaseio.com",
  projectId: "cioos-metadata-form-8d942",
  storageBucket: "cioos-metadata-form-8d942.firebasestorage.app",
  messagingSenderId: "467286137979",
  appId: "1:467286137979:web:250b09e3db2a56716016de",
  measurementId: "G-BEMJG40RHN",
};

const devConfig = {
  apiKey: import.meta.env.VITE_GOOGLE_CLOUD_API_KEY_DEV,
  authDomain: "cioos-metadata-form-dev-258dc.web.app",
  databaseURL:
    "https://cioos-metadata-form-dev-258dc-default-rtdb.firebaseio.com",
  projectId: "cioos-metadata-form-dev-258dc",
  storageBucket: "cioos-metadata-form-dev-258dc.firebasestorage.app",
  messagingSenderId: "141560007794",
  appId: "1:141560007794:web:861d99b02210ea4d17c6eb",
  measurementId: "G-BSKRHNR1EW",
};

const config =
  import.meta.env.PROD && !(deployedOnTestServer === "true")
    ? prodConfig
    : devConfig;

if (
  window.location.hostname === "localhost" &&
  localFirebaseDatabase === "true"
) {
  config.databaseURL = "http://localhost:9001?ns=cioos-metadata-form";
}

const App = initializeApp(config);

// Export the resolved config so UI components can reference values (e.g., databaseURL)
export const firebaseConfig = config;

// // uncomment below to use firebase emulator for local development
if (
  window.location.hostname === "localhost" &&
  localFirebaseFunctions === "true"
) {
  const functions = getFunctions(App);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectFunctionsEmulator(functions, "127.0.0.1", 5002);
}

export default App;
